import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CommissionForInvoiceResponse {
  /**
   * Commission ID.
   */
  id!: string;

  /**
   * Commission period in format yyyy-MM, e.g. 2021-01.
   */
  @observable
  commissionPeriod!: string;

  /**
   * Distributor's name.
   */
  @observable
  distributorName!: string;

  /**
   * Total price from which the commission is calculated in CZK.
   */
  @observable
  totalPrice!: number;

  /**
   * Commission amount in CZK.
   */
  @observable
  commissionAmount!: number;
}
